import "@/index.css";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ConvexClientProvider } from "@/lib/convex";
import SignInGate from "@/components/auth/SignInGate";
import RoleRoutes from "@/components/auth/RoleRoutes";
import ErrorBoundary from "@/components/common/ErrorBoundary";


function App() {
  return (
    <ConvexClientProvider>
      <div dir="rtl">
        <SignInGate>
          <BrowserRouter>
            <ErrorBoundary>
              <RoleRoutes />
            </ErrorBoundary>
          </BrowserRouter>
        </SignInGate>
        <Toaster position="top-center" dir="rtl" />
      </div>
    </ConvexClientProvider>
  );
}

export default App;
